import { useState } from 'react';

// services
import { wpAjax } from '../services/api';

const usePitches = () => {
  const [pitches, setPitches] = useState([]);
  const [isFetchingPitches, setIsFetchingPitches] = useState(false);

  const fetchPitches = async () => {
    setIsFetchingPitches(true);
    try {
      const data = await wpAjax('fl_fetch_pitches');
      setPitches(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to fetch pitches:', error.message);
      setPitches([]);
    } finally {
      setIsFetchingPitches(false);
    }
  };

  const updatePitch = async (pitchID, updatePitchData) => {
    try {
      await wpAjax('fl_update_pitch', {
        pitch_id: pitchID,
        ...updatePitchData
      });
      fetchPitches();
    } catch (error) {
      console.error('Failed to update pitch:', error.message);
    }
  };

  const deletePitch = async (pitchID) => {
    setPitches((prev) =>
      prev.map((p) => (p.ID === pitchID ? { ...p, isDeleting: true } : p))
    );

    try {
      await wpAjax('fl_delete_pitch', { post_id: pitchID });
      fetchPitches();
    } catch (error) {
      console.error('Failed to delete pitch:', error.message);
    }
  };

  const deletePitches = async (pitchIDs) => {
    setPitches((prev) =>
      prev.map((p) =>
        pitchIDs.includes(p.ID) ? { ...p, isDeleting: true } : p
      )
    );

    try {
      await wpAjax('fl_delete_pitches', {
        post_ids: JSON.stringify(pitchIDs)
      });
      fetchPitches();
    } catch (error) {
      console.error('Failed to delete pitches:', error.message);
    }
  };

  return {
    pitches,
    fetchPitches,
    updatePitch,
    isFetchingPitches,
    deletePitch,
    deletePitches
  };
};

export default usePitches;
